module.exports = __webpack_public_path__ + "static/media/electricals_lt.aa099605.png";